import { giphyLightGrey } from '@giphy/js-brand'
import { largeTitleSize, titleFont } from '@giphy/react-giphy-brand'
import React from 'react'
import { getLabelFromFileTypes } from 'shared/util/gif-maker-util'
import { grid12 } from 'shared/util/grid'
import styled from 'styled-components'
import { FILE_TYPES } from '../../index'
import Starter from './starter-button'
import Upload from './upload-button'

const Container = styled.div`
    background: rgba(0, 0, 0, 0.85);
    box-sizing: content-box;
    color: #fff;
    display: flex;
    margin: 50px auto 75px;
    padding: 0 20px 40px;
    width: ${grid12}px;
`

const Intro = styled.div`
    font-size: 18px;
    line-height: 1.5;
    padding: 50px 40px 0;
    width: 100%;
`

const Graphic = styled.img`
    display: block;
    height: 347px;
    margin: 0 20px;
    width: 470px;
`

const Title = styled.h1`
    font-family: ${titleFont};
    font-size: ${largeTitleSize};
    margin-bottom: 15px;
    text-align: left;
    -webkit-font-smoothing: antialiased;

    span {
        font-family: 'nexaregular', sans-serif;
    }
`

const Buttons = styled.div`
    padding: 25px 0 15px;
`

const UploadButton = styled(Upload)`
    display: inline-block;
    margin-right: 10px;
    width: 200px;
`

const StarterButton = styled(Starter)`
    width: 200px;
`

const Info = styled.div`
    box-sizing: border-box;
    color: ${giphyLightGrey};
    font-size: 15px;
    font-style: italic;
    line-height: 1.2;
    padding: 0 12px 0 22px;
    position: relative;
    width: 200px;

    i {
        left: 0;
        position: absolute;
        top: 1px;
    }
`

const ZoomMakerWelcomeIntro = () => (
    <Container>
        <Intro>
            <Title>
                GIPHY <span>Backdrop</span>
            </Title>
            <p>
                Make any video conference far more fun by creating your own Backdrop! Begin by uploading a background or
                choosing one of our starters.
            </p>
            <Buttons>
                <UploadButton gradient />
                <StarterButton />
            </Buttons>
            <Info>
                <i className="ss-info" /> We accept {getLabelFromFileTypes(FILE_TYPES)}
            </Info>
        </Intro>
        <Graphic src="/static/img/zoomies.gif" alt="" />
    </Container>
)

export default ZoomMakerWelcomeIntro
